import { data } from '../../svg/Widgets/data';
import { makeIcon } from '../makeIcon';

export const Widgets = makeIcon(data, 'widgets', 'Widgets');

export default Widgets;
